const locationType = {

    statement: {
        lookup: 'l',
        isinSelector: 'is',
        leiSelector: 'ls',
        exchangeRatesSelector: 'ers',
        annaDsbUpiEnrichmentSelector: 'annaes',
        lseSelector: 'lse',
        firdsFcaInstrumentSelector: 'firdsFcaIs',
        firdsEsmaInstrumentSelector: 'firdsEsmaIs',
        fcaRegulatedEntitiesSelector: 'fcaRegEnt',
        annaDsbUpiSelector: 'annaus',
        variable: 'v',
        aggregation: 'a',
        aggregatedRecordField: 'arf',
        filter: 'f',
        endpointFilter: 'ef',
        underReportFilter: 'urf',
        overReportFilter: 'orf',
        case: 'c',
        reportField: 'rf',
        validation: 'val',
        matchingKey: 'mk',
        matchingKeyEndPoint: 'mke',
        dictionary: 'd',
        dictionaryField: 'df',
        userDefinedFunction: 'udf',
        userDefinedFunctionParameter: 'udfp',
        validationCore: 'core',
        validationStandard: 'standard',
        symbolSelector: 'symbolsel'
    },

    pieceOfCode: {
        condition: 'c',
        conditionOperand: 'co',
        assignmentValue: 'av',
        operandsList: 'ol'
    }
};

export default locationType;